<mat-card>
  <mat-card-header>
    <div class="flex" style="width: 100%;justify-content: center;">
      <span style="font-size:1rem !important;"> <strong>แจ้งปิดระบบ</strong></span>
    </div>
  </mat-card-header>
  <mat-dialog-content>
    <div class="pl-12 pr-12 pt-4 pb-4 flex flex-col gap-4">
      <div class="flex gap-3" style="flex-direction: column;">
        <div style="text-align: center;">
          <p>สภาหอการค้าแห่งประเทศไทย ขอปิดระบบ CSC Online ชั่วคราว เนื่องด้วยเหตุผลดังนี้</p>
        </div>
        <div class="prose prose-sm max-w-none" [innerHTML]="form.lockdownReason | markdown">
        </div>
        <div style="text-align: center;">
          <p>จึงเรียนมาเพื่อทราบ และขออภัยในความไม่สะดวก
          </p>
        </div>
        <ng-container *ngIf="form.allowClose">
          <div class="flex justify-center gap-2.5" style="gap: 10px;">
            <button mat-raised-button [mat-dialog-close]>ปิด</button>
          </div>
        </ng-container>
      </div>
    </div>
  </mat-dialog-content>
</mat-card>